function initStationSelectors(root = document) {
  root.querySelectorAll('.station-selector[data-station-list]').forEach((container) => {
    if (container.dataset.initialized === 'true') return;

    const select = container.querySelector('.station-dropdown');
    if (!select) return;

    const form = container.closest('form') || container.closest('product-form');
    const selectButton = form?.querySelector('[data-station-select-button]');
    const submitButton = form?.querySelector('[data-station-submit-button]');

    const stationList = (container.dataset.stationList || '')
      .split(',')
      .map((station) => station.trim())
      .filter(Boolean);

    stationList.forEach((station) => {
      const option = document.createElement('option');
      option.value = station;
      option.textContent = station;
      select.appendChild(option);
    });

    const updateButtons = () => {
      if (!selectButton || !submitButton) return;
      if (select.value) {
        selectButton.style.display = 'none';
        submitButton.style.display = 'inline-block';
      } else {
        selectButton.style.display = 'inline-block';
        submitButton.style.display = 'none';
      }
    };

    select.addEventListener('change', updateButtons);

    if (selectButton) {
      selectButton.addEventListener('click', () => {
        select.focus();
        select.click();
      });
    }

    updateButtons();
    container.dataset.initialized = 'true';
  });
}

window.initStationSelectors = initStationSelectors;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initStationSelectors());
} else {
  initStationSelectors();
}
